import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { Route } from 'vue-router';
import store from '@/store';

/** document hooks */
export interface ITagView extends Partial<Route> {
	title?: string;
}

/** document hooks */
export interface ITagsViewState {
	visitedViews: ITagView[];
	cachedViews: (string | undefined)[];
}

/** document hooks */
@Module({
	dynamic: true,
	store,
	name: 'tagsView'
})
class TagsView extends VuexModule implements ITagsViewState {
	public visitedViews: ITagView[] = [];
	public cachedViews: (string | undefined)[] = [];

	/** document hooks */
	@Mutation
	private ADD_VISITED_VIEW(view: ITagView): any {
		if (this.visitedViews.some((v: any): any => v.path === view.path)) {
			return;
		}

		this.visitedViews.push({
			...view,
			title: view.meta.title || 'no-name'
		});
	}

	/** document hooks */
	@Mutation
	private ADD_CACHED_VIEW(view: ITagView): any {
		if (view.name === null) {
			return;
		}

		if (this.cachedViews.includes(view.name)) {
			return;
		}

		if (!view.meta.noCache) {
			this.cachedViews.push(view.name);
		}
	}

	/** document hooks */
	@Mutation
	private DEL_VISITED_VIEW(view: ITagView): any {
		for (const [i, v] of this.visitedViews.entries()) {
			if (v.path === view.path) {
				this.visitedViews.splice(i, 1);
				break;
			}
		}
	}

	/** document hooks */
	@Mutation
	private DEL_CACHED_VIEW(view: ITagView): any {
		if (view.name === null) {
			return;
		}

		const index: any = this.cachedViews.indexOf(view.name);

		if (index > -1) {
			this.cachedViews.splice(index, 1);
		}
	}

	/** document hooks */
	@Mutation
	private DEL_OTHERS_VISITED_VIEWS(view: ITagView): any {
		this.visitedViews = this.visitedViews.filter((v: any): any => v.meta.affix || v.path === view.path);
	}

	/** document hooks */
	@Mutation
	private DEL_OTHERS_CACHED_VIEWS(view: ITagView): any {
		if (view.name === null) {
			return;
		}

		const index: any = this.cachedViews.indexOf(view.name);

		if (index > -1) {
			this.cachedViews = this.cachedViews.slice(index, Number(index) + 1);
		} else {
			// if index = -1, there is no cached tags
			this.cachedViews = [];
		}
	}

	/** document hooks */
	@Mutation
	private DEL_ALL_VISITED_VIEWS(): any {
		// keep affix tags
		const affixTags: any = this.visitedViews.filter((tag: any): any => tag.meta.affix);

		this.visitedViews = affixTags;
	}

	/** document hooks */
	@Mutation
	private DEL_ALL_CACHED_VIEWS(): any {
		this.cachedViews = [];
	}

	/** document hooks */
	@Mutation
	private UPDATE_VISITED_VIEW(view: ITagView): any {
		for (let v of this.visitedViews) {
			if (v.path === view.path) {
				v = {
					...v,
					...view
				};
				break;
			}
		}
	}

	/** document hooks */
	@Action
	public addView(view: ITagView): any {
		this.ADD_VISITED_VIEW(view);
		this.ADD_CACHED_VIEW(view);
	}

	/** document hooks */
	@Action
	public addVisitedView(view: ITagView): any {
		this.ADD_VISITED_VIEW(view);
	}

	/** document hooks */
	@Action
	public delView(view: ITagView): any {
		this.DEL_VISITED_VIEW(view);
		this.DEL_CACHED_VIEW(view);
	}

	/** document hooks */
	@Action
	public delCachedView(view: ITagView): any {
		this.DEL_CACHED_VIEW(view);
	}

	/** document hooks */
	@Action
	public delOthersViews(view: ITagView): any {
		this.DEL_OTHERS_VISITED_VIEWS(view);
		this.DEL_OTHERS_CACHED_VIEWS(view);
	}

	/** document hooks */
	@Action
	public delAllViews(): any {
		this.DEL_ALL_VISITED_VIEWS();
		this.DEL_ALL_CACHED_VIEWS();
	}

	/** document hooks */
	@Action
	public delAllCachedViews(): any {
		this.DEL_ALL_CACHED_VIEWS();
	}

	/** document hooks */
	@Action
	public updateVisitedView(view: ITagView): any {
		this.UPDATE_VISITED_VIEW(view);
	}
}

/** document hooks */
export const tagsViewModule: any = getModule(TagsView);
